import React from "react";

const CourseItem = ({ data, onClick, borderClass }) => {
  return (
    <div
      key={data?.id}
      className={`d-flex flex-column justify-content-left align-items-center w-100 ${borderClass} `}
      onClick={onClick}
    >
      <h3 className="w-100 text-black fw-bold  card-header ">{data?.title}</h3>
      {data?.subtitle && (
        <p className="w-100 card-description " style={{ marginTop: "5px" }}>
          {data?.subtitle}
        </p>
      )}
    </div>
  );
};

export default CourseItem;
